<div
  class="btn-group mbs-btn-group"
  role="group"
  [ngClass]="buttonGroupClasses()">
  <ng-content />
</div>
